import buildReducer from "./build-reducer";
import { SAVE_MONTHLY_LEADERS } from "../actions/monthly-leaderboard";
import { Map } from "immutable";

let reducers = {};

reducers[SAVE_MONTHLY_LEADERS] = (state, { monthlyLeaders: monthlyLeaders }) => {
  if (monthlyLeaders === undefined) {
    return state;
  }

  let winnings = monthlyLeaders.winnings.map(winner => {
    return {
      user: Map({
        first_name: winner.first_name, // eslint-disable-line camelcase
        id: winner.user_id,
        last_name: winner.last_name, // eslint-disable-line camelcase
        username: winner.username
      }),
      wins: winner.wins,
      winnings: winner.winnings
    };
  });

  let wins = monthlyLeaders.wins.map(winner => {
    return {
      user: Map({
        first_name: winner.first_name, // eslint-disable-line camelcase
        id: winner.user_id,
        last_name: winner.last_name, // eslint-disable-line camelcase
        username: winner.username
      }),
      wins: winner.wins,
      winnings: winner.winnings
    };
  });

  const leaders = {
    winnings: winnings,
    wins: wins
  };

  console.log(leaders);

  return state.mergeDeep(leaders);
};

export default buildReducer(Map(), reducers);
